import loanSelectors from '../../../../selectors/loan/index';

export const getSearchUrl = (state, loanIdArg, searchEndPoint, userType) => {
    if(userType === 'admin'){
        const loanId = loanIdArg || loanSelectors.loanSelector.getLoanField(state, 'loanId');
        return window.config.adminApiUrl + 'loans/' + loanId + searchEndPoint;
    } else {
        return window.config.coreApiUrl + 'loans/' + loanIdArg + searchEndPoint;
    }
};
